export default function(fullName) {
    const arrName = fullName.split(' ');
    const firstAndLastName = [];
    firstAndLastName.push([...arrName[0]][0], [...arrName[arrName.length - 1]][0]);

    return firstAndLastName.join('').toUpperCase();
}